import spaceship from './wufoo-rocket.svg'
import spaceshipBoost from './wufoo-rocket-boost.svg'

const TURN_SPEED = 3
const MAX_VELOCITY = 3
const ACC_CONSTANT = 0.00005
const MISSILE_VELOCITY = 5
const MAX_MISSILES = 7

const konamiCode = [ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65 ] // UUDDLRLRBA
const charBuffer = []
const INVULNERABLE_TAGS = [ 'BODY', 'HTML' ]

const degToRad = deg => deg * (Math.PI/180)
const getTransform = (rotation) => `rotate(${rotation}deg)`

let documentWidth = 0
let documentHeight = 0
let missileCount = 0

export const initialize = () => {
  document.addEventListener('keydown', event => {
    const keyCode = event.keyCode

    if (charBuffer.length === konamiCode.length) {
      charBuffer.shift()
    }

    charBuffer.push(keyCode)

    if (charBuffer.toString() === konamiCode.toString()) {
      startDestruction()
    }
  })

  window.startDestruction = () => startDestruction()
}

const startDestruction = () => {
  initWorld()
  createSpaceship()
}

const initWorld = () => {
  const root = document.getElementById('root')
  const newRoot = root.cloneNode(true)

  root.style.display = 'none'
  document.body.appendChild(newRoot)

  const collection = [].slice.call(document.getElementsByTagName('*'))
  collection.forEach(el => {
    if (el.id === 'wufoo-ship') return
    el.style.visibility = 'visible'

    if (window.getComputedStyle(el).opacity === '0') {
      el.style.visibility = 'hidden'
    }

    if (!INVULNERABLE_TAGS.includes(el.tagName) && el.getElementsByTagName('div').length <= 1) {
      el.setAttribute('data-targeted', 'true')
    }
  })

  documentWidth = document.body.scrollWidth
  documentHeight = document.body.scrollHeight
}

const createSpaceship = () => {
  let rotation = 180
  let acceleration = 0
  let velocity = 0

  let x = window.innerWidth / 2
  let y = window.innerHeight / 2 + window.pageYOffset
  let normalX = 0
  let normalY = 0

  let boosterStarted = -1
  let brakeStarted = -1
  let turnDirection = 0

  const ship = document.createElement('img')
  ship.id = 'wufoo-ship'
  ship.setAttribute('src', spaceship)
  ship.style.position = 'absolute'
  ship.style.top = '0px'
  ship.style.left = '0px'
  ship.style.width = '24px'
  ship.style.height = '48px'
  ship.style.opacity = '0'
  ship.style.transition = 'opacity 1s ease'
  ship.style.transform = getTransform(rotation)
  ship.style['z-index'] = '9999'

  document.body.appendChild(ship)

  setTimeout(() => ship.style.opacity = '1', 0)

  document.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight') {
      turnDirection = 1
    } else if (event.key === 'ArrowLeft') {
      turnDirection = -1
    } else if (event.key === 'ArrowUp') {
      boosterStarted = new Date().getTime()
    } else if (event.key === 'ArrowDown') {
      brakeStarted = new Date().getTime()
    } else if (event.keyCode === 32) {
      const spawnX = x + 12 + (24*Math.sin(degToRad(rotation)))
      const spawnY = y + 24 - (24*Math.cos(degToRad(rotation)))

      if (missileCount <= MAX_MISSILES) {
        spawnMissile(spawnX, spawnY, normalX, normalY)
      }
    } else {
      return
    }

    event.preventDefault()
    event.stopPropagation()
  })

  document.addEventListener('keyup', event => {
    if (event.key === 'ArrowRight') {
      turnDirection = 0
    } else if (event.key === 'ArrowLeft') {
      turnDirection = 0
    } else if (event.key === 'ArrowUp') {
      boosterStarted = -1
      acceleration = 0
    } else if (event.key === 'ArrowDown') {
      brakeStarted = -1
      acceleration = 0
    } else if (event.key === 'Space') {
      // noop
    } else {
      return
    }

    event.preventDefault()
    event.stopPropagation()
  })

  const process = () => {
    const timestamp = new Date().getTime()

    normalX = Math.sin(degToRad(rotation))
    normalY = Math.cos(degToRad(rotation))

    x = x + velocity * normalX
    y = y + velocity * -normalY

    if (boosterStarted > 0) acceleration += (timestamp - boosterStarted) * ACC_CONSTANT
    if (brakeStarted > 0) acceleration -= (timestamp - brakeStarted) * ACC_CONSTANT

    velocity += acceleration

    if (velocity < 0) velocity = 0
    if (velocity > MAX_VELOCITY) velocity = MAX_VELOCITY

    rotation += turnDirection * TURN_SPEED
  }

  setInterval(process, 1000 / 60)

  const update = () => {
    ship.style.transform = getTransform(rotation)
    ship.style.left = `${x}px`
    ship.style.top = `${y}px`

    ship.setAttribute('src', boosterStarted < 0 ? spaceship : spaceshipBoost)

    window.requestAnimationFrame(update)
  }

  window.requestAnimationFrame(update)
}

const spawnMissile = (initialX, initialY, normalX, normalY) => {
  let x = initialX
  let y = initialY

  missileCount += 1

  const missile = document.createElement('div')

  missile.id = 'wufoo-missile'
  missile.style.position = 'absolute'
  missile.style.left = `${x + 12}px`
  missile.style.top = `${y + 12}px`
  missile.style.width = '2px'
  missile.style.height = '2px'
  missile.style.background = '#444'
  missile.style['border-radius'] = '2px'
  missile.style['z-index'] = '9998'

  document.body.appendChild(missile)

  const process = () => {
    x = x + MISSILE_VELOCITY * normalX
    y = y + MISSILE_VELOCITY * -normalY

    const elements = document.elementsFromPoint(x, y).filter(el => {
      return (
        el.id !== 'wufoo-ship' &&
        !el.hasAttribute('data-destroyed') &&
        el.hasAttribute('data-targeted')
      )
    })

    if (elements.length > 0) {
      elements.forEach(el => setTimeout(removeElement(el), 0))
      missile.remove()
      missileCount -= 1
      return
    }

    if (x < 0 || x > documentWidth || y < 0 || y > documentHeight) {
      missile.remove()
      missileCount -= 1
      return
    }

    setTimeout(process, 1000 / 60)
  }

  setTimeout(process, 1000 / 60)

  const update = () => {
    missile.style.left = `${x}px`
    missile.style.top = `${y}px`

    window.requestAnimationFrame(update)
  }

  window.requestAnimationFrame(update)
}

const removeElement = el => {
  el.setAttribute('data-destroyed', 'true')
  el.style.transition = 'all 1s ease'
  el.style.opacity = '0'
  el.style.transform = 'scale(1.5)'
  setTimeout(() => {
    el.style.visibility = 'hidden'
  }, 1000)
}
